const ScrollMagic = require('ScrollMagic');
require('animation.gsap');
require('debug.addIndicators');

function marketingUmbrellaParallax() {
  if(window.innerWidth > 1024){
    // init
    const controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 'onLeave'
      }
    });

    // get all slides
    const slides = document.querySelectorAll("section.panel");

    // create scene for every slide
    for (let i=0; i<slides.length; i++) {
      new ScrollMagic.Scene({
        triggerElement: slides[i]
      })
      .setPin(slides[i])
      .addTo(controller);
    }
  }
}

$(function () { // wait for document ready
  marketingUmbrellaParallax()

});

